var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"primary"},[_c('span',{staticClass:"white--text headline"},[_vm._v(_vm._s(_vm.$t('defects')))]),_c('v-spacer'),_c('BaseDialogActions',{attrs:{"hideFullscreen":"","hideRefresh":""}})],1),_c('v-card-text',[_c('DefectTable',{attrs:{"ticketDefects":_vm.ticketDefects}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }